import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CBIPMPP } from './cbip-mpp';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNDrugPackage extends CNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNDrugPackage';
    }

    get name() {
        return this.getProperty('fr');
    }

    get price() {
        return this.getProperty('price');
    }

    get mpp(): CBIPMPP {
        return this.child$('SNItem.CBIP.MPP');
    }

    public clone(): any {
        return new CNDrugPackage();
    }
}
